import { useTranslation } from 'react-i18next';
import { ArrowRight, PlayCircle, CheckCircle } from 'lucide-react';
import Reveal from '../../components/Reveal';
import DashboardMock from './DashboardMock';
import { WHATSAPP } from './constants';

const TRUST_KEYS = ['users', 'setup', 'secure'];

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section id="home" className="relative overflow-hidden bg-gradient-to-b from-violet-50 via-purple-50 to-white py-20 px-6">
      {/* Decorative blobs */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 -left-24 w-72 h-72 bg-violet-300/15 rounded-full blur-3xl animate-blob" />
        <div className="absolute top-10 -right-20 w-72 h-72 bg-purple-300/15 rounded-full blur-3xl animate-blob" style={{ animationDelay: '2s' }} />
        <div className="absolute bottom-0 left-1/3 w-72 h-72 bg-indigo-200/15 rounded-full blur-3xl animate-blob" style={{ animationDelay: '4s' }} />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <span className="inline-block text-xs font-semibold uppercase tracking-widest text-violet-600 bg-violet-100 px-3 py-1 rounded-full mb-5 animate-fade-in-up">
            {t('landing.hero.badge')}
          </span>
          <h1
            className="text-4xl sm:text-5xl font-extrabold leading-tight bg-gradient-to-r from-violet-600 to-indigo-600 bg-clip-text text-transparent animate-fade-in-up"
            style={{ animationDelay: '100ms' }}
          >
            {t('landing.hero.headline')}
          </h1>
          <p className="text-gray-500 mt-5 max-w-lg text-base leading-relaxed animate-fade-in-up" style={{ animationDelay: '200ms' }}>
            {t('landing.hero.subhead')}
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3 animate-fade-in-up" style={{ animationDelay: '300ms' }}>
            <a
              href={WHATSAPP}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-violet-600 to-purple-600 text-white text-sm font-semibold px-6 py-3 rounded-xl shadow-lg shadow-violet-500/10 hover:shadow-violet-500/20 hover:scale-105 transition-all"
            >
              {t('landing.hero.ctaPrimary')}
              <ArrowRight size={16} />
            </a>
            <a
              href={WHATSAPP}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 bg-white text-gray-700 text-sm font-semibold px-6 py-3 rounded-xl border border-gray-200 hover:border-violet-300 hover:text-violet-600 transition-colors"
            >
              <PlayCircle size={16} />
              {t('landing.hero.ctaSecondary')}
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-gray-400 animate-fade-in-up" style={{ animationDelay: '400ms' }}>
            {TRUST_KEYS.map(k => (
              <span key={k} className="flex items-center gap-1.5">
                <CheckCircle size={14} className="text-emerald-500" />
                {t(`landing.hero.trust.${k}`)}
              </span>
            ))}
          </div>
        </div>

        <Reveal delay={150}>
          <DashboardMock variant="hero" />
        </Reveal>
      </div>
    </section>
  );
}
